import { render, staticRenderFns } from "./BankSelections.vue?vue&type=template&id=e18c5c88"
import script from "./BankSelections.vue?vue&type=script&lang=js"
export * from "./BankSelections.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports